module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-news-item', {
    attrs: {
      "title": "Resumo"
    }
  }, [(_vm.grv.patio.naoEmitirBoleto) ? _c('div', {
    staticClass: "row m-t-xs"
  }, [_c('div', {
    staticClass: "col-xs-12 text-danger text-xs"
  }, [_vm._v("(Sem emissão de boleto)")])]) : _vm._e(), _vm._v(" "), (_vm.dataAgendamento) ? _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Data do agendamento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 font-bold item-d",
    staticStyle: {
      "color": "#d35400"
    }
  }, [_vm._v(_vm._s(_vm.formataData(_vm.dataAgendamento)) + " ")])]) : (_vm.dataLimiteGratuidade) ? _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Data limite de gratuidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 font-bold item-d",
    staticStyle: {
      "color": "#d35400"
    }
  }, [_vm._v(_vm._s(_vm.formataDataGratuidade(_vm.dataLimiteGratuidade)) + " ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Apreensão:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 font-bold item-d"
  }, [_vm._v(_vm._s(_vm.datasExtraModel.dataApreensao) + " " + _vm._s(_vm.datasExtraModel.horaApreensao))])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Remoção:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 font-bold item-d"
  }, [_vm._v(_vm._s(_vm.datasExtraModel.dataRemocao) + " " + _vm._s(_vm.datasExtraModel.horaRemocao))])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Entrada no pátio:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 font-bold item-d"
  }, [_vm._v(_vm._s(_vm.moment(_vm.grv.ggv.dataCadastro.date).format('L')) + "\n      " + _vm._s(_vm.moment(_vm.grv.ggv.dataCadastro.date).format('LTS')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Pátio:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 font-bold item-d"
  }, [_vm._v(_vm._s(_vm.grv.patio.nome) + " (#" + _vm._s(_vm.grv.patio.id) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Vaga:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 font-bold item-d"
  }, [_vm._v(_vm._s(_vm.grv.vaga || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("Número da chave:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 font-bold item-d"
  }, [_vm._v(_vm._s(_vm.grv.numeroChave || '-'))])]), _vm._v(" "), (_vm.grv.liberarPorDecisaoJudicial) ? _c('div', {
    staticClass: "row m-t"
  }, [_c('div', {
    staticClass: "col-xs-12 font-bold item-d",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("LIBERADO POR DECISÃO JUDICIAL")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ef3fe93","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv-patio/CardNewsItemResumo.vue
// module id = 1769
// module chunks = 18